import { useState } from 'react';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import styles from './PostCard.module.css';
import { Link } from 'react-router-dom';

const PostCard = ({ data, username }) => {
  const [hasLoaded, setHasLoaded] = useState(false);

  const calcHeight = () => {
    const width = data.dimensions.width;
    const height = data.dimensions.height;

    const heightPercent = (height / width) * 100;

    return `${heightPercent}%`;
  };

  const isHidden = () => {
    if (hasLoaded) {
      return {
        width: '100%',
        display: 'flex',
      };
    } else {
      return {
        display: 'none',
      };
    }
  };

  return (
    <div className={styles.container}>
      {!hasLoaded && (
        <div className={styles.placeholder} style={{ paddingBottom: calcHeight() }}></div>
      )}
      <Link to={`/user/${username}/image/${data.id}`} style={{ width: '100%' }}>
        <div style={isHidden()}>
          <img
            src={`${process.env.REACT_APP_SERVER_URL}/user/${username}/image/${data.id}`}
            alt=""
            className={styles.image}
            onLoad={() => setHasLoaded(true)}
          ></img>
          <div className={styles.overlay}>
            <SearchRoundedIcon className={styles.zoomIcon} style={{ fontSize: '2.5rem' }} />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default PostCard;
